import { SET_SEARCH_ENGINE_STATUS } from './types';
export default {
  [SET_SEARCH_ENGINE_STATUS](state, payload) {
    var currentState = state;
    currentState.isSearchEngine = payload;
  }

};